/* eslint-disable react/jsx-key */
import clsx from 'clsx';

import styles from '../../styles.module.scss';
import ImageDesktop1 from '../images/safari-desktop-1.png';
import ImageDesktop2 from '../images/safari-desktop-2.png';
import ImageDesktop3 from '../images/safari-desktop-3.png';
import ImageMobile1 from '../images/safari-mobile-1.png';
import ImageMobile2 from '../images/safari-mobile-2.png';
import ImageMobile3 from '../images/safari-mobile-3.png';

export const listDesktop = [
    <div className={clsx(styles.contentDesktop, styles.center)}>
        В&nbsp;меню Safari&nbsp;
        <img src={ImageDesktop1} alt='' />
        &nbsp; выберите пункт &laquo;Настройки...&raquo;
    </div>,
    <div className={clsx(styles.contentDesktop, styles.column)}>
        Перейдите на&nbsp;вкладку &laquo;Веб-сайты&raquo;, в&nbsp;боковом меню выберите раздел &laquo;Микрофон&raquo;&nbsp;/ &laquo;Камера&raquo;
        <img className={styles.image} src={ImageDesktop2} alt='' />
    </div>,
    <div className={clsx(styles.contentDesktop, styles.column)}>
        В&nbsp;списке веб-сайтов найдите meetings.trendrealty.ru и&nbsp;разрешите доступ
        <img className={styles.image} src={ImageDesktop3} alt='' />
    </div>,
];

export const listMobile = [
    <div className={styles.contentMobile}>
        Нажмите на&nbsp;значок с&nbsp;2&nbsp;заглавными &laquo;А&raquo;
        <br />
        в&nbsp;адресной строке
        <img src={ImageMobile1} alt='' />
    </div>,
    <div className={styles.contentMobile}>
        Перейдите в&nbsp;раздел
        <br />
        &laquo;Настройки веб-сайта&raquo;
        <img src={ImageMobile2} alt='' />
    </div>,
    <div className={styles.contentMobile}>
        Разрешите доступ
        <br />
        для микрофона&nbsp;/ камеры
        <img src={ImageMobile3} alt='' />
    </div>,
];
